import React from 'react';

const RadioS1 = ({options, checked, onChange}) => {
	return (
		<div className='radio-rows'>

			{options.map(option => {
				const isChecked = option.value === checked;
				return(
					<div className='radio-button-wrap'>
						<div className={`radio-button ${isChecked ? '--checked' : ''}`} onClick={() => onChange(option)}>
							<span className='radio-button-check'></span>
							<div>{option.label}</div>
						</div>
					</div>
				)
			})}

		</div>
	);
};

export default RadioS1;
